var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { UsersTable } from 'src/ui/views/users/sections/UsersTable/UsersTable';
import { Pagination } from 'src/ui/views/cases/sections/Pagination/Pagination';
import UsersListFilters from 'src/ui/views/users/sections/UsersListFilters';
import { UsersParams } from 'src/ui/views/users/sections/UsersParams/UsersParams';
import { UserDetailsModal } from 'src/ui/views/users/components/UserDetailsModal';
import { E_USER_MODAL } from 'src/ui/views/users/components/constants';
import { UserDeleteModal } from 'src/ui/views/users/components/UserDeleteModal';
import styles from './users.module.scss';
import { UsersImportModal } from 'src/ui/views/users/components/UsersImportModal/UsersImportModal';
export var Users = function (props) {
    var _a;
    var i18n = props.i18n, users = props.users, isUsersLoading = props.isUsersLoading, groups = props.groups, filters = props.filters, columns = props.columns, currentUser = props.currentUser, isImportLoading = props.isImportLoading, usersImportResult = props.usersImportResult, fetchUsersRequested = props.fetchUsersRequested, updateFilters = props.updateFilters, exportUsersInCSV = props.exportUsersInCSV, fetchCurrentUserDetailsRequested = props.fetchCurrentUserDetailsRequested, clearCurrentUser = props.clearCurrentUser, updateUserRequested = props.updateUserRequested, deleteUserRequested = props.deleteUserRequested, importUsersInCSVRequested = props.importUsersInCSVRequested, clearUsersImport = props.clearUsersImport, isUsersImportDisplayed = props.isUsersImportDisplayed;
    var collection = users.collection, nbOfPages = users.nbOfPages, nbByPage = users.nbByPage, currentPages = users.currentPages, total = users.total;
    var _b = useState(null), userModalIsOpen = _b[0], setUserModalIsOpen = _b[1];
    var _c = useState(false), isCreateUser = _c[0], setIsCreateUser = _c[1];
    var isSearchEnabled = ((_a = filters === null || filters === void 0 ? void 0 : filters.search) === null || _a === void 0 ? void 0 : _a.length) !== 0;
    useEffect(function () {
        if (filters) {
            fetchUsersRequested();
        }
    }, [filters]);
    var handleOnPageChange = function (newPage) {
        updateFilters({ offset: (newPage - 1) * nbByPage });
    };
    var handleOnResultsPerPageChange = function (count) {
        updateFilters({ count: count, offset: 0 });
    };
    var handleModalClose = function () {
        setUserModalIsOpen(null);
        clearCurrentUser();
        setIsCreateUser(false);
        clearUsersImport();
    };
    var handleCreateUserOpenModal = function () {
        setIsCreateUser(true);
        setUserModalIsOpen(E_USER_MODAL.USER_DETAILS);
    };
    var handleEditUser = function (user) {
        fetchCurrentUserDetailsRequested(user.id);
        setUserModalIsOpen(E_USER_MODAL.USER_DETAILS);
    };
    var handleDeleteUserOpenModal = function (user) {
        fetchCurrentUserDetailsRequested(user.id);
        setUserModalIsOpen(E_USER_MODAL.DELETE_USER);
    };
    var handleUpdateUser = function (user) {
        updateUserRequested(user);
        handleModalClose();
    };
    var handleDeleteUser = function (user) {
        deleteUserRequested(user);
        handleModalClose();
    };
    var handleImportUsersOpenModal = function () {
        setUserModalIsOpen(E_USER_MODAL.IMPORT_USER);
    };
    var handleImportUsers = function (file) {
        importUsersInCSVRequested(file);
    };
    return (_jsxs(_Fragment, { children: [userModalIsOpen === E_USER_MODAL.USER_DETAILS && (_jsx(UserDetailsModal, { i18n: i18n, isCreation: isCreateUser, groupsCollection: groups, user: currentUser, onCancel: handleModalClose, onSave: handleUpdateUser })), userModalIsOpen === E_USER_MODAL.DELETE_USER && (_jsx(UserDeleteModal, __assign({ i18n: i18n }, currentUser, { onCancel: handleModalClose, onValidateClick: handleDeleteUser }))), userModalIsOpen === E_USER_MODAL.IMPORT_USER && (_jsx(UsersImportModal, { i18n: i18n, isImportLoading: isImportLoading, result: usersImportResult, onClose: handleModalClose, onImport: handleImportUsers, onReset: clearUsersImport })), _jsxs("section", __assign({ className: styles.usersWrapper }, { children: [_jsx(UsersListFilters, {}), _jsx(UsersParams, { i18n: i18n, onExport: exportUsersInCSV, onCreateUser: handleCreateUserOpenModal, onImportUsers: isUsersImportDisplayed ? handleImportUsersOpenModal : null }), _jsxs("div", __assign({ className: styles.tableWrapper }, { children: [_jsx(UsersTable, { i18n: i18n, users: collection, isLoading: isUsersLoading, columns: columns, onEditUser: handleEditUser, onDeleteUser: handleDeleteUserOpenModal }), _jsx(Pagination, { i18n: i18n, total: total, nbByPage: nbByPage, nbOfPages: nbOfPages, currentPage: currentPages, onPageChange: handleOnPageChange, onResultsPerPageChange: handleOnResultsPerPageChange, isResultsPerPageDisabled: isSearchEnabled })] }))] }))] }));
};
